/* ------------------------------------------------------------------
   Mr. Football - live "Buy 2 Get 1 Free" progress bar.

   Design: a bold black banner echoing the site's own top announcement
   bar ("BUY 2 GET 1 FREE / ADD 3 ITEMS TO CART") rather than a quiet
   bordered box, switching to a rich green banner once a free item is
   unlocked. Storewide offer, so copy says "item(s)" - never "kit" - it
   is not limited to jerseys. The unlocked state states the exact dollar
   amount saved directly in the message, not just in the side badge.

   Renders inside every cart form on the page (drawer + full /cart page
   both need it). Watches document.body broadly and polls as a fallback
   so hydration timing can't make it silently fail to appear. See
   templates/cart.bogo.liquid for the eligibility rules this mirrors.

   Remove by deleting this file and its script_tag in snippets/cart-mini.liquid.
------------------------------------------------------------------ */
(function () {
  'use strict';
  if (window.__mfBogo) { return; }
  window.__mfBogo = true;

  var SET_SIZE = 3; // buy 2 + 1 free

  var ICON_SHIRT = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.38 3.46 16 2a4 4 0 0 1-8 0L3.62 3.46a2 2 0 0 0-1.34 2.23l.58 3.47a1 1 0 0 0 .99.84H6v10a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V10h2.15a1 1 0 0 0 .99-.84l.58-3.47a2 2 0 0 0-1.34-2.23Z"/></svg>';
  var ICON_CHECK = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';

  function moneyFormat() {
    try {
      var el = document.getElementById('cart-config');
      if (el) {
        var cfg = JSON.parse(el.textContent);
        if (cfg && cfg.money_format) { return cfg.money_format; }
      }
    } catch (e) {}
    return '${{amount}}';
  }

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    return moneyFormat()
      .replace(/\{\{\s*amount\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(cents / 100)))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, String(Math.round(cents / 100)));
  }

  function injectStyles() {
    if (document.getElementById('mf-bogo-css')) { return; }
    var css = [
      '.mf-bogo{grid-column:1/-1;width:100%;max-width:100%;box-sizing:border-box;position:relative;display:block;overflow:hidden;padding:16px 18px;margin:0 0 10px;background:var(--button-color,#000);color:var(--button-text,#fff);font-family:var(--main-family,inherit);transition:background-color .35s ease}',
      '.mf-bogo *{box-sizing:border-box}',
      '.mf-bogo.is-unlocked{background:var(--success-msg-dark,#007f5f)}',
      '.mf-bogo__top{display:flex;align-items:center;justify-content:space-between;gap:10px;flex-wrap:wrap;margin-bottom:12px}',
      '.mf-bogo__title{display:flex;align-items:center;gap:8px;font-family:var(--heading-family,inherit);font-weight:800;font-size:13px;letter-spacing:.14em;text-transform:uppercase;color:#fff;margin:0}',
      '.mf-bogo__title svg{flex:0 0 auto}',
      '.mf-bogo__save{font-size:11px;font-weight:800;letter-spacing:.04em;color:var(--success-msg-dark,#007f5f);background:#fff;padding:5px 11px;white-space:nowrap;animation:mfBogoPop .45s cubic-bezier(.3,1.5,.4,1)}',
      '@keyframes mfBogoPop{0%{transform:scale(.75);opacity:0}65%{transform:scale(1.08);opacity:1}100%{transform:scale(1)}}',
      '.mf-bogo__track{position:relative;width:100%;height:10px;background:rgba(255,255,255,.22);overflow:hidden;margin-bottom:12px;border-radius:var(--button-border-radius,0)}',
      '.mf-bogo__fill{position:relative;height:100%;width:0%;background:var(--sale-color,#bc0000);transition:width .6s cubic-bezier(.25,.9,.3,1);overflow:hidden}',
      '.mf-bogo.is-unlocked .mf-bogo__fill{background:#fff}',
      '.mf-bogo__fill::after{content:\'\';position:absolute;inset:0;background:linear-gradient(90deg,transparent,rgba(255,255,255,.55),transparent);transform:translateX(-100%);animation:mfBogoShimmer 2s ease-in-out infinite}',
      '@keyframes mfBogoShimmer{100%{transform:translateX(100%)}}',
      '.mf-bogo__marks{position:absolute;top:0;bottom:0;left:0;right:0;display:flex;pointer-events:none}',
      '.mf-bogo__marks i{flex:1;border-right:2px solid var(--button-color,#000)}',
      '.mf-bogo.is-unlocked .mf-bogo__marks i{border-right-color:var(--success-msg-dark,#007f5f)}',
      '.mf-bogo__marks i:last-child{border-right:0}',
      '.mf-bogo__msg{margin:0;font-size:13px;line-height:1.5;color:#fff}',
      '.mf-bogo__msg b{font-weight:800}',
      '.mf-bogo__hint{margin:6px 0 0;font-size:11px;color:#fff;opacity:.75}',
      '@media (min-width:741px){',
        '.mf-bogo{padding:20px 24px}',
        '.mf-bogo__title{font-size:14px}',
        '.mf-bogo__track{height:13px}',
        '.mf-bogo__msg{font-size:15px}',
      '}'
    ].join('');
    var tag = document.createElement('style');
    tag.id = 'mf-bogo-css';
    tag.textContent = css;
    document.head.appendChild(tag);
  }

  function build(data) {
    var wrap = document.createElement('div');
    wrap.className = 'mf-bogo';
    wrap.setAttribute('data-mf-bogo', '');

    var unlocked = data.free_slots > 0 && data.get_qty > 0;
    if (unlocked) { wrap.className += ' is-unlocked'; }

    var posInSet = data.buy_qty % SET_SIZE;
    var pct = data.buy_qty === 0 ? 0 : (posInSet === 0 ? 100 : Math.round((posInSet / SET_SIZE) * 100));

    var top = document.createElement('div');
    top.className = 'mf-bogo__top';
    var title = document.createElement('p');
    title.className = 'mf-bogo__title';
    title.innerHTML = (unlocked ? ICON_CHECK : ICON_SHIRT) + '<span>Buy 2 Get 1 Free</span>';
    top.appendChild(title);

    if (unlocked && data.total_discounts > 0) {
      var save = document.createElement('span');
      save.className = 'mf-bogo__save';
      save.textContent = 'Saving ' + formatMoney(data.total_discounts);
      top.appendChild(save);
    }
    wrap.appendChild(top);

    var track = document.createElement('div');
    track.className = 'mf-bogo__track';
    var fill = document.createElement('div');
    fill.className = 'mf-bogo__fill';
    fill.style.width = pct + '%';
    track.appendChild(fill);
    var marks = document.createElement('div');
    marks.className = 'mf-bogo__marks';
    for (var i = 0; i < SET_SIZE; i++) { marks.appendChild(document.createElement('i')); }
    track.appendChild(marks);
    wrap.appendChild(track);

    var msg = document.createElement('p');
    msg.className = 'mf-bogo__msg';

    if (unlocked) {
      var itemWord = data.free_slots === 1 ? 'item' : 'items';
      if (data.total_discounts > 0) {
        msg.innerHTML = '<b>' + data.free_slots + ' free ' + itemWord + ' unlocked — you’re saving ' + formatMoney(data.total_discounts) + '!</b> Applied automatically at checkout.';
      } else {
        msg.innerHTML = '<b>' + data.free_slots + ' free ' + itemWord + ' unlocked.</b> Applied automatically at checkout.';
      }
    } else if (data.buy_qty === 0) {
      msg.innerHTML = 'Add <b>3 items</b> and the cheapest one is <b>free</b>.';
    } else {
      var word = data.needed === 1 ? 'item' : 'items';
      msg.innerHTML = 'Add <b>' + data.needed + ' more ' + word + '</b> and your cheapest is <b>free</b>';
      msg.innerHTML += data.cheapest_price > 0
        ? ' &mdash; that is ' + formatMoney(data.cheapest_price) + ' off.'
        : '.';
    }
    wrap.appendChild(msg);

    if (unlocked && data.needed > 0) {
      var hint = document.createElement('p');
      hint.className = 'mf-bogo__hint';
      var w2 = data.needed === 1 ? 'item' : 'items';
      hint.textContent = 'Add ' + data.needed + ' more ' + w2 + ' to unlock another free one.';
      wrap.appendChild(hint);
    }

    return wrap;
  }

  var busy = false;
  var lastSignature = null;

  function neededForms() {
    return Array.prototype.filter.call(
      document.querySelectorAll('.js-ajax-cart-content .js-cart-form'),
      function (form) { return !!form.querySelector('.ajax-cart__cart-items'); }
    );
  }

  function render() {
    var forms = neededForms();
    if (!forms.length || busy) { return; }

    busy = true;
    fetch('/cart?view=bogo', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (txt) {
        if (!txt) { return; }
        var data;
        try { data = JSON.parse(txt.trim()); } catch (e) { return; }
        if (!data || !data.item_count) {
          document.querySelectorAll('[data-mf-bogo]').forEach(function (el) { el.remove(); });
          lastSignature = null;
          return;
        }
        var signature = data.buy_qty + ':' + data.get_qty + ':' + data.total_discounts;
        forms.forEach(function (form) {
          var anchor = form.querySelector('.ajax-cart__cart-items');
          if (!anchor) { return; }
          var current = form.querySelector('[data-mf-bogo]');
          if (current && signature === lastSignature) { return; }
          var block = build(data);
          if (current && current.parentNode) {
            current.parentNode.replaceChild(block, current);
          } else {
            anchor.parentNode.insertBefore(block, anchor);
          }
        });
        lastSignature = signature;
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  function watch() {
    var timer = null;
    var debounced = function () {
      clearTimeout(timer);
      timer = setTimeout(render, 110);
    };
    new MutationObserver(debounced).observe(document.body, { childList: true, subtree: true });
    setInterval(render, 700);
    render();
  }

  function boot() { injectStyles(); watch(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();